<template>
  <div>
    <!--    driver name-->
    <v-row
      style="border-bottom: 1px solid #E5E7EB;"
      class="margin-0"
    >
      <v-col
        class="d-flex justify-start driver-label"
      >
        <div
          class="driver-label--wrapper"
        >
          {{ item.user ? item.user : '--' }}
        </div>
      </v-col>
    </v-row>

    <!--    visible data section-->
    <v-row
      v-for="(dataObject, dataObjIndex) in getVisibleItemDetails()"
      :key="dataObjIndex"
      class="margin-0"
    >
      <v-col
        class="data-label"
      >
        {{ dataObject.label }}
      </v-col>

      <v-col
        class="d-flex justify-end data-value"
      >
        {{ dataObject.value }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { dateService, FORMATS } from '@/global/services/date'
export default {
  name: 'ReadoutsGridBlock',

  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    itemIndex: {
      type: Number,
      default: 0
    }
  },

  methods: {
    getVisibleItemDetails () {
      return [
        {
          label: this.$t('fleet/vehicle.readout_datetime'),
          value: this.item?.datetime ? dateService.formatFromUtc(this.item.datetime, FORMATS.datetimeShort) : '--'
        },
        {
          label: this.$t('fleet/vehicle.readout_type'),
          value: this.item?.type?.name || '--'
        },
        {
          label: this.$t('fleet/vehicle.readout_value'),
          value: this.item?.value || '--'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.driver-label {
  display: flex;
  justify-content: flex-start;
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #111827;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.driver-label--wrapper {
  display: flex;
  height: 48px;
  align-items: center;
}

.data-label {
  font-family: 'Satoshi', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #6B7280;
}

.data-value {
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #111827;
  text-align: right;
}
</style>
